import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { css } from "styled-components";

searchHistoryStyles.clearLink = {
    typographyProps: {
        css: css`
            width: 100%;
            text-align: left;
            margin-top: 10px;
        `,
    },
}